import React from 'react';
import { Divider, Typography } from 'fronton-react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { useRecoilValue } from 'recoil';
import { AddedProductsTitle, ComplementaryProductsBox, ComplimentaryProductInfoContainer } from './styles';
import { MainProduct } from './MainProduct';
import { ComplementaryProduct } from './ComplementaryProduct';
import { useRobotintMutationObserver } from './hooks';

export const ComplementaryProductsComponent = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { complimentaryProductInfo } = dimensions;
  useRobotintMutationObserver();

  return (
    <ComplementaryProductsBox>
      <MainProduct />
      {!!complimentaryProductInfo.length && (
        <>
          <AddedProductsTitle>
            <Typography variant="h3">Расходники и инструменты</Typography>
          </AddedProductsTitle>
          <ComplimentaryProductInfoContainer>
            {complimentaryProductInfo.map((item, i) =>
              item.salesPriceValueInConsumerUnitValue ? (
                <>
                  <ComplementaryProduct
                    product={item}
                    index={i}
                    isDisabled={!dimensions.checkedProducts[i].isChecked}
                    key={item.productId}
                  />
                  {complimentaryProductInfo.length - 1 !== i && <Divider />}
                </>
              ) : null
            )}
          </ComplimentaryProductInfoContainer>
        </>
      )}
    </ComplementaryProductsBox>
  );
};
